import { Loading } from '@/layouts/loading'
import { createFileRoute } from '@tanstack/react-router'
import Component from './-components/component'

export const Route = createFileRoute('/technician/_layout/worklist/')({
    component: Component,
    pendingComponent: () => <Loading />,
    pendingMinMs: 1000,
    pendingMs: 1
})